import React, { useMemo } from 'react';
import { Box, Typography, Paper, Stack } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { useDashboard } from '../../../contexts/DashboardContext';

export default function DashboardStats({ panelId, outputKey = 'stats_data', config }) {
  const { getSlice } = useDashboard();
  const raw = getSlice(panelId, outputKey);

  const items = useMemo(() => {
    if (!raw) return [];
    const arr = Array.isArray(raw) ? raw : raw?.items ?? [];
    return arr.map((item, i) => ({
      id: item.id ?? i,
      label: item.label ?? item.name ?? '',
      value: item.value ?? item.value_formatted ?? '-',
      trend: item.trend,
      unit: item.unit ?? '',
    }));
  }, [raw]);

  if (!items.length) {
    return (
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 120 }}>
        <Typography color="text.secondary">No stats. Use chat or refresh to run a flow.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, height: '100%', overflow: 'auto' }}>
      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
        {items.map((item) => (
          <Paper
            key={item.id}
            variant="outlined"
            sx={{
              p: 2,
              minWidth: 120,
              flex: '1 1 120px',
            }}
          >
            <Typography variant="caption" color="text.secondary">
              {item.label}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
              <Typography variant="h5">
                {item.value}{item.unit}
              </Typography>
              {item.trend != null && (
                item.trend >= 0
                  ? <TrendingUpIcon sx={{ fontSize: 18, color: 'success.main' }} />
                  : <TrendingDownIcon sx={{ fontSize: 18, color: 'error.main' }} />
              )}
            </Box>
          </Paper>
        ))}
      </Stack>
    </Box>
  );
}
